(() => {
  if (customElements.get('pyk-product-details')) return;
  class ProductDetails extends HTMLElement {
    animations = new WeakMap();

    setExpanded(details, open) {
      const previous = this.animations.get(details);
      const start = details.getBoundingClientRect().height;
      if (previous) {
        previous.animation.cancel();
        this.animations.delete(details);
      }
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const summary = details.querySelector(':scope > summary');
      const resetChildren = () => {
        details.querySelectorAll('details[open]').forEach(child => {
          const running = this.animations.get(child);
          if (running) running.animation.cancel();
          this.animations.delete(child);
          child.removeAttribute('data-closing');
          child.style.height = '';
          child.style.overflow = '';
          child.open = false;
        });
      };
      details.removeAttribute('data-closing');
      details.style.height = '';
      details.style.overflow = '';
      if (reducedMotion || !details.animate) {
        details.open = open;
        if (!open) resetChildren();
        return;
      }
      if (open) details.open = true;
      else details.setAttribute('data-closing', '');
      const end = open ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderTopWidth || 0) + parseFloat(getComputedStyle(details).borderBottomWidth || 0);
      details.style.overflow = 'hidden';
      const animation = details.animate([{height: `${start}px`}, {height: `${end}px`}], {duration:220, easing:'cubic-bezier(.2,.7,.2,1)'});
      this.animations.set(details, {animation, open});
      animation.onfinish = () => {
        this.animations.delete(details);
        details.open = open;
        details.removeAttribute('data-closing');
        details.style.height = '';
        details.style.overflow = '';
        if (!open) resetChildren();
      };
    }

    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const source = this.querySelector('[data-pyk-description]');
      if (source) {
        source.querySelectorAll('.accordion-item').forEach(item => {
          const header = item.querySelector(':scope > .accordion-item-header');
          const body = item.querySelector(':scope > .accordion-item-body');
          if (!header || !body) return;
          const details = document.createElement('details');
          details.className = 'pyk-product-details__question';
          if (item.id) details.id = item.id;
          const summary = document.createElement('summary');
          summary.className = 'pyk-product-details__toggle';
          const label = document.createElement('span');
          label.textContent = header.textContent.trim();
          summary.append(label);
          body.classList.remove('accordion-item-body');
          body.classList.add('pyk-product-details__answer');
          ['max-height', 'height', 'overflow', 'display'].forEach(property => body.style.removeProperty(property));
          details.append(summary, body);
          item.replaceWith(details);
        });
        const descriptionGroup = source.parentElement;
        const hasContent = element => element.textContent.trim() || element.querySelector('img, table, video, iframe, audio');
        const markers = Array.from(source.querySelectorAll('h2, h3, h4, p, details.pyk-product-details__question')).filter(element => {
          if (element.parentElement.closest('details') !== descriptionGroup) return false;
          if (element.tagName !== 'P') return true;
          const label = element.textContent.trim().replace(/:$/, '').trim();
          return /^(key features|important information)$/i.test(label) && element.querySelector('strong, b');
        });
        const groups = [];
        markers.reverse().forEach(marker => {
          const range = document.createRange();
          range.setStartAfter(marker);
          range.setEnd(source, source.childNodes.length);
          const following = range.extractContents();
          const answer = document.createElement('div');
          answer.className = 'pyk-product-details__source';
          const label = document.createElement('span');
          if (marker.tagName === 'DETAILS') {
            label.append(...marker.querySelector('summary > span').childNodes);
            const body = marker.querySelector('.pyk-product-details__answer');
            answer.append(...body.childNodes);
          } else {
            label.append(...marker.childNodes);
          }
          answer.append(following);
          const details = document.createElement('details');
          details.className = 'pyk-product-details__group';
          const summary = document.createElement('summary');
          summary.className = 'pyk-product-details__toggle';
          summary.append(label);
          if (marker.id) details.id = marker.id;
          details.append(summary, answer);
          marker.remove();
          if (hasContent(answer)) groups.unshift(details);
          else if (label.textContent.trim()) {
            const heading = document.createElement('p');
            heading.append(...label.childNodes);
            source.append(heading);
          }
        });
        descriptionGroup.after(...groups);
        if (!hasContent(source)) descriptionGroup.remove();
      }
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary.pyk-product-details__toggle');
        if (!summary || !this.contains(summary) || event.target.closest('a, button, input, select')) return;
        event.preventDefault();
        const details = summary.parentElement;
        const open = !(this.animations.get(details)?.open ?? details.open);
        if (open && details.classList.contains('pyk-product-details__question')) {
          Array.from(details.parentElement.children).forEach(sibling => {
            if (sibling !== details && sibling.matches('details.pyk-product-details__question') && sibling.open) this.setExpanded(sibling, false);
          });
        }
        this.setExpanded(details, open);
      });
      this.addEventListener('toggle', event => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        if (this.animations.has(details)) return;
        if (!details.open) {
          details.querySelectorAll('details[open]').forEach(child => { child.open = false; });
        } else if (details.classList.contains('pyk-product-details__question')) {
          Array.from(details.parentElement.children).forEach(sibling => {
            if (sibling !== details && sibling.matches('details.pyk-product-details__question')) sibling.open = false;
          });
        }
      }, true);
    }
  }
  customElements.define('pyk-product-details', ProductDetails);
})();
